import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="avatar-preview"
// Shows a live preview of a newly selected avatar file.
export default class extends Controller {
  static targets = ["input", "image", "placeholder"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    if (this.url) URL.revokeObjectURL(this.url)
    this.url = URL.createObjectURL(file)

    this.imageTarget.src = this.url
    this.imageTarget.classList.remove("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
  }

  disconnect() {
    if (this.url) URL.revokeObjectURL(this.url)
  }
}
